export enum VatSituation {
	StandardVat,
	VatZeroPercent,
	ReverseVat,
	NoVat,
}
